import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';

import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';

import { updateForm, updateTextForm } from 'store/Admin/Analyser';
import { updateTextOfTextList } from 'store/Admin/OrderDisplay';

export const useAdminPutToDraft = ({
  t,
  actualHtmlContent,
  actualTextContent,
  analyseResult,
  keyword,
  metaDescriptionTag,
  list,
  combinedKeywords,
  websites,
  stuffedKeywords,
  textTitle,
  titleTag,
  url,
  textId,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setErrorSuccess,
}) => {
  const dispatch = useDispatch();

  const putToDraft = () => {
    const data = {
      actualHtmlContent,
      actualTextContent,
      analyseResult: analyseResult && JSON.stringify(analyseResult),
      keyword,
      metaDescriptionTag,
      semanticGap: list ? transformToSemanticGap(combinedKeywords) : null,
      internalLinking: websites,
      stuffedKeywords: stuffedKeywords,
      textTitle: textTitle,
      titleTag: titleTag,
      url: url,
    };

    axiosPrivate
      .put(`/texts/${textId}/putToDraft`, data)
      .then((res) => {
        dispatch(updateForm(res.data));
        dispatch(updateTextForm({ key: 'delivered', value: false }));
        dispatch(
          updateTextOfTextList({
            id: textId,
            key: 'delivered',
            value: false,
          })
        );

        dispatch(
          updateTextOfTextList({
            id: textId,
            key: 'verifiedByAdmin',
            value: false,
          })
        );
        setErrorSuccessMsg(
          `${t('Le texte')} ${textTitle} ${t('a été mis en brouillon')}!`
        );
        setErrorSuccessImg(animationUrl + '/04_Contenu_validé.gif');

        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch(() => {
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return { putToDraft };
};
